import { render } from "./LiveResults.vue?vue&type=template&id=1b7953b8"
import script from "./LiveResults.vue?vue&type=script&lang=js"
export * from "./LiveResults.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__